import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import { calculateNowTime } from "../../services/sharedService";
import { Modal, Row } from "react-bootstrap";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { useSnackbar } from "material-ui-snackbar-provider";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "react-toastify";

const ProfileRow = ({ profile, properties, loadData, openAssignLLModal }) => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { user, checkIeDetails } = authContext;
  const landLordContext = useContext(LandLordContext);
  const { editSharedProfile, editAgencySharedProfile } = landLordContext;
  const navigate = useNavigate();
  const [linkedPropertiesModel, setLinkedPropertiesModel] = useState(false);
  const [defaultPropertyLink, setDefaultPropertyLink] = useState([]);
  const [selectBtn, setSelectBtn] = useState(_t("select") + "...");
  const [propertyLink, setPropertyLink] = useState([]);
  const snackbar = useSnackbar();
  const [propertyLinkedLoading, setPropertyLinkedLoading] = useState(false);

  useEffect(() => {
    if (haveValue(properties) && haveValue(profile)) {
      if (haveValue(profile.propertyid)) {
        const temp_arr = [];
        var result = profile.propertyid.map((id) => {
          const obj = properties.find((item) => item._id === id);
          if (obj) {
            temp_arr.push(
              `${obj.street} - ${obj.street_number}, ${obj.floor_number}-${obj.flat_number}`
            );
            return {
              value: obj?._id,
              label: `${obj.street} - ${obj.street_number}, ${obj.floor_number}-${obj.flat_number}`,
            };
          }
          return null; // Handle case where id is not found in array1
        });

        result = result.filter((val) => haveValue(val));

        var placeholder_string = [];

        temp_arr.forEach((val) => {
          placeholder_string.push(
            <span className="placeholder_string">{val}</span>
          );
        });
        if (placeholder_string.length == 0) setSelectBtn(_t("select") + "...");
        else setSelectBtn(placeholder_string);

        setPropertyLink(profile?.propertyid);
        setDefaultPropertyLink(result);
      }
    }
  }, [properties, profile]);

  const calculateScore = (userDetails) => {
    var result = 0;

    if (checkIeDetails(userDetails)) {
      var totalScore =
        (userDetails?.paymentScores?.creditScore?.value || 0) / 2;

      if (userDetails?.is_university) {
        if (totalScore >= 600) {
          totalScore += 200;
        } else {
          totalScore += 400;
        }
      }
      if (totalScore > 850) {
        totalScore = 850;
      }
      result = totalScore;
    } else {
      if (haveValue(userDetails?.paymentScores?.creditScore?.value)) {
        result = userDetails?.paymentScores?.creditScore?.value;
      }
    }

    return result;
  };

  const propList = properties.map((prop) => ({
    value: prop?._id,
    label: `${prop?.street} - ${prop?.street_number}, ${prop.floor_number}-${prop.flat_number}`,
  }));

  const handlePropSelect = async (e) => {
    const temp = e.map((val) => val.value);
    console.log(selectBtn);
    var placeholder_string = [];

    const tempArr = propList.filter((val) => temp.includes(val?.value));

    tempArr.forEach((val) => {
      placeholder_string.push(
        <span className="placeholder_string">{val?.label}</span>
      );
    });

    if (placeholder_string.length == 0) setSelectBtn(_t("select") + "...");
    else setSelectBtn(placeholder_string);
    setPropertyLink(temp);
  };

  const handleLinkProperty = async (e, filtered = null) => {
    var sendData = null;
    if (haveValue(propertyLink)) {
      sendData = propertyLink;
    }
    if (haveValue(filtered)) {
      sendData = filtered;
    }
    if (haveValue(sendData)) {
      // console.log([...sendData],)
      const data = {
        property_id: sendData,
        // property_id: properties[propertyLink]._id
      };
      setPropertyLinkedLoading(true);
      if (user?.isParentLL) {
        await editAgencySharedProfile(profile?._id, data)
          .then(async (res) => {
            loadData();
            if (haveValue(filtered)) {
              snackbar.showMessage(_t("propertyUnlinked"));
            } else {
              snackbar.showMessage(_t("propertyLinked"));
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setPropertyLinkedLoading(false);
          });
      } else {
        await editSharedProfile(profile?._id, data)
          .then(async (res) => {
            loadData();
            if (haveValue(filtered)) {
              snackbar.showMessage(_t("propertyUnlinked"));
            } else {
              snackbar.showMessage(_t("propertyLinked"));
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setPropertyLinkedLoading(false);
          });
      }
    } else {
      toast.error(_t("pleaseSelectPropertyToLink"));
    }
  };

  const handleUnlinkProperty = (propertyId) => {
    const temp = [...propertyLink];

    const filtered = temp.filter((val) => val != propertyId);

    setPropertyLink(filtered);
    handleLinkProperty({}, filtered);
  };

  return (
    <>
      <tr
        className={`second-row ${
          (profile?.tenantid?.myScore || 0) <= 50 ? "red-row" : ""
        }`}
      >
        <td>
          {profile?.tenantid?.fname ?? "N/A"} {profile?.tenantid?.lname}
        </td>
        <td>
          {haveValue(profile?.tenantid?.gurantor_id?.paymentScores)
            ? profile?.tenantid?.gurantor_id?.paymentScores?.creditScore?.value
            : calculateScore(profile?.tenantid)}
        </td>
        <td>--</td>
        <td>
          <div className="d-flex align-items-center">
          <div
            onClick={() => setLinkedPropertiesModel(true)}
            className={`d-flex align-items-center bg-[#DBF1CA] cursor-pointer bg_test  ${profile?.propertyid?.length === 0 ? 'btngreen' : "link_property_bg"}`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="button_iconset"
            >
              <path
                d="M9.63608 0.263511L17.7346 8.36362C18.3015 8.93062 17.9001 9.89989 17.0984 9.89989H16.1986V15.2999C16.1986 16.0161 15.9142 16.7028 15.4079 17.2092C14.9017 17.7155 14.215 18 13.499 18H12.5992V11.6999C12.5992 11.0113 12.3362 10.3486 11.8638 9.84747C11.3915 9.34642 10.7455 9.04478 10.0581 9.00442L9.89973 8.99989H8.10005C7.38412 8.99989 6.69748 9.28435 6.19125 9.79075C5.68498 10.2971 5.40058 10.9838 5.40058 11.6999V18H4.50074C3.78478 18 3.09816 17.7155 2.5919 17.2092C2.08565 16.7028 1.80124 16.0161 1.80124 15.2999V9.89989H0.901408C0.100554 9.89989 -0.301671 8.93062 0.265223 8.36362L8.36369 0.263511C8.53247 0.0947847 8.76128 0 8.99989 0C9.23849 0 9.46736 0.0947847 9.63608 0.263511ZM9.89973 10.7999C10.1384 10.7999 10.3673 10.8947 10.536 11.0635C10.7048 11.2323 10.7996 11.4613 10.7996 11.6999V18H7.20026V11.6999C7.20026 11.4795 7.28115 11.2667 7.42764 11.102C7.57408 10.9372 7.77589 10.832 7.9948 10.8062L8.10005 10.7999H9.89973Z"
                fill="#253837"
              />
            </svg>
            {profile?.propertyid?.length === 0 ? (
              "Link Property"
            ) : (
              <>
                <p className="linked_p">{profile?.propertyid?.length}</p>
                <svg
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 10.7222L6 6.00001L1 1.27778"
                    stroke="#253837"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </>
            )}
          </div>
          </div>
        </td>
        {user?.isParentLL && (
          <td>
            <button
              className="btn btngreen assignToLLBtn assignToLLBtn2"
              id="assignToLLBtn"
              onClick={(e) => openAssignLLModal(profile?.tenantid?._id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 16 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="button_iconset"
              >
                <path
                  d="M7.33333 4.66666V5.99999H6V7.33332H4.66667V5.99999H3.86667C3.6 6.79999 2.86667 7.33332 2 7.33332C0.866667 7.33332 0 6.46666 0 5.33332C0 4.19999 0.866667 3.33332 2 3.33332C2.86667 3.33332 3.6 3.86666 3.86667 4.66666H7.33333ZM2 4.66666C1.6 4.66666 1.33333 4.93332 1.33333 5.33332C1.33333 5.73332 1.6 5.99999 2 5.99999C2.4 5.99999 2.66667 5.73332 2.66667 5.33332C2.66667 4.93332 2.4 4.66666 2 4.66666ZM10.6667 7.33332C12.4667 7.33332 16 8.19999 16 9.99999V11.3333H5.33333V9.99999C5.33333 8.19999 8.86667 7.33332 10.6667 7.33332ZM10.6667 5.99999C9.2 5.99999 8 4.79999 8 3.33332C8 1.86666 9.2 0.666656 10.6667 0.666656C12.1333 0.666656 13.3333 1.86666 13.3333 3.33332C13.3333 4.79999 12.1333 5.99999 10.6667 5.99999Z"
                  fill="#223635"
                />
              </svg>

              {_t(
                "assignToLandlord",
                "Button on landlord side in tenant profile listing page for Parent LL to share profile with another Sub LL"
              )}
            </button>
          </td>
        )}
        <td className="progressbar_section">
        <div className="position-relative" role="progressbar" style={{ "--value": profile?.tenantid?.myScore || 0}}>
        </div>
          {/* <div className="position-relative steps-progress-bar processbar_step">
            <div class="circle">
              <div
                class="mask full"
                style={{
                  transform: `rotate(${
                    (profile?.tenantid?.myScore || 0) * 1.8
                  }deg)`,
                }}
              >
                <div
                  class="fill"
                  style={{
                    transform: `rotate(${
                      (profile?.tenantid?.myScore || 0) * 1.8
                    }deg)`,
                  }}
                ></div>
              </div>
              <div class="mask half">
                <div
                  class="fill"
                  style={{
                    transform: `rotate(${
                      (profile?.tenantid?.myScore || 0) * 1.8
                    }deg)`,
                  }}
                ></div>
              </div>
            </div>
            <div class="inside-circle inside-circle2">
              {" "}
              {profile?.tenantid?.myScore || 0}%{" "}
            </div>
          </div> */}
        </td>
        <td>{calculateNowTime(profile?.createdAt)}</td>

        <td>
          <div
            onClick={() => {
              user?.isParentLL
                ? navigate(`/profile-property?agencylink=${profile?._id}`)
                : navigate(`/profile-property?sharedprofileid=${profile?._id}`);
            }}
            className="cursor-pointer"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15L8 8L1 1"
                stroke="#253837"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </td>
      </tr>
      <Modal
        show={linkedPropertiesModel}
        onHide={() => setLinkedPropertiesModel(false)}
        centered
        className="newmodalui asguarantor"
      >
        <Row className="card-listing mt-0 custm_select_btn">
          <div className="custm_select_btn_head mb-3">
            <p className="titlebar_new">
              {_t("linkedProperties")}: {profile?.propertyid?.length ?? 0}
            </p>
            <div
              className="cursor-pointer"
              onClick={() => setLinkedPropertiesModel(false)}
            >
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.7734 1.32064C16.8453 1.24881 16.9022 1.16352 16.9411 1.06966C16.98 0.975805 17 0.875207 17 0.773615C17 0.672022 16.98 0.571424 16.9411 0.477565C16.9022 0.383706 16.8453 0.298423 16.7734 0.226586C16.7016 0.15475 16.6163 0.0977657 16.5224 0.058888C16.4286 0.0200102 16.328 0 16.2264 0C16.1248 0 16.0242 0.0200102 15.9303 0.058888C15.8365 0.0977657 15.7512 0.15475 15.6794 0.226586L8.5 7.40749L1.32064 0.226586C1.24881 0.15475 1.16352 0.0977657 1.06966 0.058888C0.975805 0.0200102 0.875207 7.56923e-10 0.773615 0C0.672022 -7.56923e-10 0.571424 0.0200102 0.477565 0.058888C0.383706 0.0977657 0.298423 0.15475 0.226586 0.226586C0.15475 0.298423 0.0977657 0.383706 0.058888 0.477565C0.0200102 0.571424 -7.56923e-10 0.672022 0 0.773615C7.56923e-10 0.875207 0.0200102 0.975805 0.058888 1.06966C0.0977657 1.16352 0.15475 1.24881 0.226586 1.32064L7.40749 8.5L0.226586 15.6794C0.0815054 15.8244 0 16.0212 0 16.2264C0 16.4316 0.0815054 16.6283 0.226586 16.7734C0.371667 16.9185 0.568439 17 0.773615 17C0.97879 17 1.17556 16.9185 1.32064 16.7734L8.5 9.59251L15.6794 16.7734C15.8244 16.9185 16.0212 17 16.2264 17C16.4316 17 16.6283 16.9185 16.7734 16.7734C16.9185 16.6283 17 16.4316 17 16.2264C17 16.0212 16.9185 15.8244 16.7734 15.6794L9.59251 8.5L16.7734 1.32064Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          <div className="link-property prime-selectmulti multiselect-tenant mb-3">
            <ReactMultiSelectCheckboxes
              key={JSON.stringify(defaultPropertyLink)}
              isMulti
              name="link_property"
              id="link_property"
              options={propList}
              className="basic-multi-select form-control link_prop_select"
              classNamePrefix="select"
              placeholderButtonLabel={selectBtn}
              getDropdownButtonLabel={function getDropdownButtonLabel(_ref3) {
                return selectBtn;
              }}
              selectedOptions={defaultPropertyLink}
              onChange={handlePropSelect}
              defaultValue={defaultPropertyLink}
            />

            <button
              type="button"
              className="btn btngreen"
              onClick={handleLinkProperty}
              disabled={!haveValue(propertyLink) || propertyLinkedLoading}
            >
              {_t("saveChanges")}
            </button>
          </div>

          {properties
            .filter((property) => profile?.propertyid?.includes(property._id))
            .map((property) => (
              <div
                key={property._id}
                className="paymentdeailbarleft paymentdeailbarleft2"
              >
                <div className="list_set_data">
                  <div>
                  <p>{`${property?.street} - ${property?.street_number}, ${property.floor_number}-${property.flat_number}`}</p>
                  </div>
                  <div>
                  <button onClick={(e) => handleUnlinkProperty(property?._id)}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.4 2.73171H9.6C9.6 2.31771 9.43143 1.92067 9.13137 1.62793C8.83131 1.33519 8.42435 1.17073 8 1.17073C7.57565 1.17073 7.16869 1.33519 6.86863 1.62793C6.56857 1.92067 6.4 2.31771 6.4 2.73171ZM5.2 2.73171C5.2 2.37297 5.27242 2.01775 5.41314 1.68633C5.55385 1.3549 5.7601 1.05376 6.0201 0.800099C6.28011 0.546436 6.58878 0.34522 6.92849 0.207939C7.2682 0.0706577 7.6323 0 8 0C8.3677 0 8.7318 0.0706577 9.07151 0.207939C9.41123 0.34522 9.7199 0.546436 9.9799 0.800099C10.2399 1.05376 10.4461 1.3549 10.5869 1.68633C10.7276 2.01775 10.8 2.37297 10.8 2.73171H15.4C15.5591 2.73171 15.7117 2.79338 15.8243 2.90316C15.9368 3.01293 16 3.16182 16 3.31707C16 3.47232 15.9368 3.62121 15.8243 3.73099C15.7117 3.84077 15.5591 3.90244 15.4 3.90244H14.344L13.408 13.3549C13.3362 14.0792 12.9904 14.7514 12.4381 15.2404C11.8859 15.7295 11.1666 16.0003 10.4208 16H5.5792C4.83349 16.0001 4.11448 15.7292 3.56236 15.2402C3.01024 14.7512 2.66459 14.0791 2.5928 13.3549L1.656 3.90244H0.6C0.44087 3.90244 0.288258 3.84077 0.175736 3.73099C0.063214 3.62121 0 3.47232 0 3.31707C0 3.16182 0.063214 3.01293 0.175736 2.90316C0.288258 2.79338 0.44087 2.73171 0.6 2.73171H5.2ZM6.8 6.43902C6.8 6.28378 6.73679 6.13489 6.62426 6.02511C6.51174 5.91533 6.35913 5.85366 6.2 5.85366C6.04087 5.85366 5.88826 5.91533 5.77574 6.02511C5.66321 6.13489 5.6 6.28378 5.6 6.43902V12.2927C5.6 12.4479 5.66321 12.5968 5.77574 12.7066C5.88826 12.8164 6.04087 12.878 6.2 12.878C6.35913 12.878 6.51174 12.8164 6.62426 12.7066C6.73679 12.5968 6.8 12.4479 6.8 12.2927V6.43902ZM9.8 5.85366C9.95913 5.85366 10.1117 5.91533 10.2243 6.02511C10.3368 6.13489 10.4 6.28378 10.4 6.43902V12.2927C10.4 12.4479 10.3368 12.5968 10.2243 12.7066C10.1117 12.8164 9.95913 12.878 9.8 12.878C9.64087 12.878 9.48826 12.8164 9.37574 12.7066C9.26321 12.5968 9.2 12.4479 9.2 12.2927V6.43902C9.2 6.28378 9.26321 6.13489 9.37574 6.02511C9.48826 5.91533 9.64087 5.85366 9.8 5.85366ZM3.7872 13.2425C3.83035 13.677 4.0378 14.0802 4.36909 14.3735C4.70039 14.6669 5.1318 14.8294 5.5792 14.8293H10.4208C10.8682 14.8294 11.2996 14.6669 11.6309 14.3735C11.9622 14.0802 12.1697 13.677 12.2128 13.2425L13.1392 3.90244H2.8608L3.7872 13.2425Z"
                        fill="#EF7833"
                      />
                    </svg>
                  </button>
                  </div>
                </div>
              </div>
            ))}
        </Row>
      </Modal>
    </>
  );
};

export default ProfileRow;
